<template>
	<footer class="footer ">
		<div class="footer__container text-micro container">
			<div class="footer__company">
				<div class="footer__company-info ">
					<div class="col">
						<a class="a-none-deco mb-1" :href="content.domain" target="_blank">{{ content.name }}</a>
						<a class="a-none-deco" target="_blank" :href="content.googleMaps">{{ content.address }}</a>
					</div>

					<div class="col">
						<a class="a-none-deco mb-1" target="_blank" :href="`mailto:${content.email}`">{{ content.email }}</a>
						<a class="a-none-deco" :href="`tel:${content.phone}`">{{ content.phone }}</a>
					</div>
					<div class="col">
						<a class="mb-1" v-for="link in links" :href="link.slug" :key="link.title">{{ link.title }}</a>
					</div>
				</div>
				<div class="footer__company-qualifications row pull-right">
					<Icon v-for="icon in qualifications" :key="icon.action" :icon="icon" />
				</div>
			</div>

			<div class="footer__bottom row between">
				<div class="footer__copyright">
					&copy; {{ year }}
					<a :href="content.domain" target="_blank">{{ content.name }}</a>
				</div>
				<button class="footer__scroll-action row end" @click="scroll">Scroll til toppen</button>
			</div>
		</div>
	</footer>
</template>

<script>
import Icon from '@/components/Icon'
export default {
	props: {
		content: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			year: new Date().getFullYear(),
		}
	},
	computed: {
		qualifications() {
			if (!this.$path(this.content, 'qualifications')) return []
			return this.content.qualifications.map(item => {
				return {
					src: item.url,
					alt: item.alt,
					action: item.customData.link,
				}
			})
		},
		links() {
			return this.$path(this.content, 'links')
		},
	},
	methods: {
		scroll() {
			return setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 0)
		},
	},
	components: {
		Icon,
	},
}
</script>

<style lang="scss">
@import '@/styles/base/_color.scss';
@import '@/styles/base/_variables.scss';
@import '@/styles/utils/_mixins.scss';

.footer {
	text-transform: uppercase;
	padding: 4rem 0 2rem 0;
	color: $dark;
	background: $secondary;

	&__container {
		display: grid;
		grid-template-rows: repeat(2, 1fr);
		grid-gap: 3rem;
		align-items: center;

		@include respond-below('phone') {
			grid-template-rows: auto;
			max-width: 300px;

			justify-content: center;
			text-align: center;
		}
	}
	&__company {
		display: grid;
		grid-template-columns: 1.5fr 1fr;
		@include respond-below('phone') {
			grid-template-columns: 1fr;
		}

		&-info {
			display: flex;
			justify-content: flex-start;

			font-weight: 700;
			& > * {
				margin-right: 3em;
			}
			@include respond-below('phone') {
				justify-content: center;
				text-align: center;
				flex-direction: column;
				& > * {
					margin: 1em 0;
				}
			}
		}
		&-qualifications {
			margin: initial !important;

			justify-content: flex-end;
			& > * {
				margin-left: 0.75em;
			}

			@include respond-below('phone') {
				flex-flow: row wrap;
				justify-content: center;
				& > * {
					margin: 0.5em 1em;
				}
			}
		}
	}
	&__copyright {
		white-space: nowrap;
		@include respond-below('phone') {
			margin-top: 3rem;
		}
	}

	&__bottom {
		@include respond-below('phone') {
			flex-direction: column-reverse;
			align-items: center;
		}
	}
	&__scroll-action {
		cursor: pointer;
		text-transform: uppercase;
		&::before {
			content: '↑ ';
			transition: 0.5s;
			margin-right: 0.3rem;
			transform: translateY(-2px);
		}

		&:hover::before {
			transition: 1s;
			transform: translateY(-7px);
		}
	}
	a {
		color: inherit;
		text-decoration: none;
	}
}
</style>
